/**
 * PDI Loyalty International API v1.5.20
 * Note: All dates/times returned via API call will be UTC / Accept-Encoding: gzip, deflate<br><br><a href='https://pditechnologies.com/engage-customers/loyalty-marketing-solutions/'>PDI Technologies website</a><br><a href='mailto:azpiral-info@pditechnologies.com?subject=AzpiralAPI'>Send an email to PDI Technologies</a><br><a href='../../Contents/FlowDiagrams/Index.htm'>Flow Diagrams</a><br><a href='../../v1/Helpers/ApiErrors/'>Error Codes</a>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CartDetailLine from './CartDetailLine';
import CouponInfoObj from './CouponInfoObj';

/**
 * The CartInfoCou model module.
 * @module model/CartInfoCou
 * @version v1
 */
class CartInfoCou {
    /**
     * Constructs a new <code>CartInfoCou</code>.
     * @alias module:model/CartInfoCou
     * @param membersName {String} MaxLength:130
     * @param pointsBalance {Number} 
     * @param pointsValue {Number} 
     * @param orderPoints {Number} 
     * @param detail {Array.<module:model/CartDetailLine>} 
     */
    constructor(membersName, pointsBalance, pointsValue, orderPoints, detail) { 
        
        CartInfoCou.initialize(this, membersName, pointsBalance, pointsValue, orderPoints, detail);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, membersName, pointsBalance, pointsValue, orderPoints, detail) { 
        obj['MembersName'] = membersName;
        obj['PointsBalance'] = pointsBalance;
        obj['PointsValue'] = pointsValue;
        obj['OrderPoints'] = orderPoints;
        obj['Detail'] = detail;
    }

    /**
     * Constructs a <code>CartInfoCou</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CartInfoCou} obj Optional instance to populate.
     * @return {module:model/CartInfoCou} The populated <code>CartInfoCou</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CartInfoCou();

            if (data.hasOwnProperty('MembersName')) {
                obj['MembersName'] = ApiClient.convertToType(data['MembersName'], 'String');
            }
            if (data.hasOwnProperty('PointsBalance')) {
                obj['PointsBalance'] = ApiClient.convertToType(data['PointsBalance'], 'Number');
            }
            if (data.hasOwnProperty('PointsValue')) {
                obj['PointsValue'] = ApiClient.convertToType(data['PointsValue'], 'Number');
            }
            if (data.hasOwnProperty('OrderPoints')) {
                obj['OrderPoints'] = ApiClient.convertToType(data['OrderPoints'], 'Number');
            }
            if (data.hasOwnProperty('Detail')) {
                obj['Detail'] = ApiClient.convertToType(data['Detail'], [CartDetailLine]);
            }
            if (data.hasOwnProperty('Coupons')) {
                obj['Coupons'] = ApiClient.convertToType(data['Coupons'], [CouponInfoObj]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CartInfoCou</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CartInfoCou</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of CartInfoCou.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['MembersName'] && !(typeof data['MembersName'] === 'string' || data['MembersName'] instanceof String)) {
            throw new Error("Expected the field `MembersName` to be a primitive type in the JSON string but got " + data['MembersName']);
        }
        if (data['Detail']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['Detail'])) {
                throw new Error("Expected the field `Detail` to be an array in the JSON data but got " + data['Detail']);
            }
            // validate the optional field `Detail` (array)
            for (const item of data['Detail']) {
                CartDetailLine.validateJSON(item);
            };
        }
        if (data['Coupons']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['Coupons'])) {
                throw new Error("Expected the field `Coupons` to be an array in the JSON data but got " + data['Coupons']);
            }
            // validate the optional field `Coupons` (array)
            for (const item of data['Coupons']) {
                CouponInfoObj.validateJSON(item);
            };
        }

        return true;
    }


}

CartInfoCou.RequiredProperties = ["MembersName", "PointsBalance", "PointsValue", "OrderPoints", "Detail"];

/**
 * MaxLength:130
 * @member {String} MembersName
 */
CartInfoCou.prototype['MembersName'] = undefined;

/**
 * @member {Number} PointsBalance
 */
CartInfoCou.prototype['PointsBalance'] = undefined;

/**
 * @member {Number} PointsValue
 */
CartInfoCou.prototype['PointsValue'] = undefined;

/**
 * @member {Number} OrderPoints
 */
CartInfoCou.prototype['OrderPoints'] = undefined;

/**
 * @member {Array.<module:model/CartDetailLine>} Detail
 */
CartInfoCou.prototype['Detail'] = undefined;

/**
 * @member {Array.<module:model/CouponInfoObj>} Coupons
 */
CartInfoCou.prototype['Coupons'] = undefined;






export default CartInfoCou;

